import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

/**
 * События обновления данных.
 * Впоследствии тут можно докрутить отлов событий между вкладками или Server-sent events
 */
@Injectable()
export class DataEventsService {
    // localStorageEvents$ = fromEvent(window, 'storage');

    /**
     * Изменилась карточка оборудования.
     * Передается id карточки.
     */
    equipmentCardUpdate$ = new Subject<number>();
}
